import { css } from '@emotion/react'
import { normalize } from 'polished'
import { theme } from '../theme'

export const globalCSS = css`
  ${normalize()};
  html, body, #root, #router {
    height: 100%;
    background: ${theme.colors.background.lightgray};
  }
  h1, h2, h3, h4, h5 {
    margin: 0;
    padding: 0
  }
`